import {ROUTER_DATA_LOAD_FULFILLED} from '../router/router-actions';

export const initialState = () => ({
    featuredSpots: {isPending: false, data: null},
});

export default function midfunnelReducer(
    state = initialState(),
    {type, payload}
) {
    switch (type) {
        case ROUTER_DATA_LOAD_FULFILLED: {
            return payload.midfunnel || initialState();
        }

        default:
            return state;
    }
}
